module.exports = __webpack_public_path__ + "img/iverson-react-with-typescript.11918766.png";